import { Component, OnInit, ViewContainerRef, viewChild } from '@angular/core';
import { Modal } from '../../modal';
import { showHide } from '../../modal-animations';

@Component({
  selector: 'app-modal-template-clean',
  templateUrl: './modal-template-clean.component.html',
  styleUrls: ['./modal-template-clean.component.scss'],

  animations: [showHide],
})
export class ModalTemplateCleanComponent extends Modal implements OnInit {
  readonly contentRef = viewChild('content', { read: ViewContainerRef });

  constructor() {
    super();
  }

  ngOnInit() {}
}
